export function temperatureIsCompliant(temperature, rule) {
  const value = Number(String(temperature).replace(',', '.'));
  const tolerance = Number(rule?.tolerance_c ?? 0);
  const mode = rule?.limit_mode || 'RANGE';
  const minimum = rule?.minimum_temperature_c ?? rule?.min_temperature_c;
  const maximum = rule?.maximum_temperature_c ?? rule?.max_temperature_c;
  if (!Number.isFinite(value) || !Number.isFinite(tolerance) || tolerance < 0) return false;

  if (mode === 'RANGE') {
    const min = Number(minimum);
    const max = Number(maximum);
    return Number.isFinite(min) && Number.isFinite(max)
      && value >= min - tolerance && value <= max + tolerance;
  }
  if (mode === 'MAX_ONLY') {
    const max = Number(maximum);
    return minimum == null && Number.isFinite(max) && value <= max + tolerance;
  }
  if (mode === 'MIN_ONLY') {
    const min = Number(minimum);
    return maximum == null && Number.isFinite(min) && value >= min - tolerance;
  }
  return false;
}

export function temperatureLimitLabel(rule, prefix = 'Limiti') {
  const mode = rule?.limit_mode || 'RANGE';
  const minimum = rule?.minimum_temperature_c ?? rule?.min_temperature_c;
  const maximum = rule?.maximum_temperature_c ?? rule?.max_temperature_c;
  const tolerance = Number(rule?.tolerance_c ?? 0);
  const lead = prefix ? `${prefix}: ` : '';
  const toleranceText = tolerance > 0 ? ` · tolleranza ±${tolerance}°C` : '';
  if (mode === 'MAX_ONLY' && maximum != null) {
    return `${lead}massimo ${maximum}°C${toleranceText}`;
  }
  if (mode === 'MIN_ONLY' && minimum != null) {
    return `${lead}minimo ${minimum}°C${toleranceText}`;
  }
  if (mode === 'RANGE' && minimum != null && maximum != null) {
    return `${lead}${minimum}°C–${maximum}°C${toleranceText}`;
  }
  return `${lead}configurazione non disponibile`;
}
